<div class="header">
  <div>
    <div class="al-page-title">
      <a
        class="al-page-back al-relief-icon al-relief-icon--large al-icon--chevron-left"
        routerLink="/academy"
        [attr.aria-label]="'academy.backToAcademy' | translate"
        [nbTooltip]="'academy.backToAcademy' | translate"
        nbTooltipPlacement="right"
      ><span class="al-relief-glyph" aria-hidden="true"></span></a>
      <h2>{{ title }}</h2>
    </div>
    <p class="subtitle" *ngIf="description">{{ description }}</p>
  </div>
</div>

<app-page-loader *ngIf="!ready"></app-page-loader>

<nb-card *ngIf="ready && topic" class="topic-card">
  <nb-card-header>
    <div class="topic-card__head">
      <span class="academy-topic-icon">
        <nb-icon [icon]="topic.icon" [pack]="topic.iconPack || 'eva'"></nb-icon>
      </span>
      <span class="academy-chip academy-chip--muted topic-card__step">
        {{ 'academy.topic.step' | translate: { n: number, total: totalTopics } }}
      </span>
      <div class="topic-card__progress">
        <app-academy-progress [done]="completed" [total]="rows.length"></app-academy-progress>
      </div>
      <a
        *ngIf="firstOpen"
        nbButton
        status="primary"
        size="small"
        [routerLink]="['/academy/lessons', firstOpen.id]"
      >
        {{ (completed ? 'academy.topic.continue' : 'academy.topic.start') | translate }}
        <nb-icon icon="arrow-forward-outline"></nb-icon>
      </a>
    </div>
  </nb-card-header>
  <nb-card-body>
    <nb-list alAnchor="academy.lesson-list">
      <nb-list-item *ngFor="let r of rows; let i = index; trackBy: trackRow">
        <div class="topic-row">
          <app-academy-lesson-item
            [lesson]="r.lesson"
            [title]="r.title"
            [status]="r.status"
            [summary]="r.summary"
            [index]="i"
            [compact]="true"
            [showStatus]="true"
          ></app-academy-lesson-item>
        </div>
      </nb-list-item>
    </nb-list>
  </nb-card-body>
  <nb-card-footer *ngIf="certId || nextTopic" class="topic-card__footer">
    <a *ngIf="certId" class="topic-card__cert" [routerLink]="['/academy/certificates', certId]">
      <nb-icon icon="award-outline"></nb-icon>
      {{ 'academy.topic.countsFor' | translate: { name: certTitle } }}
    </a>
    <a *ngIf="nextTopic" class="topic-card__cert" [routerLink]="['/academy/topics', nextTopic.topic.id]">
      {{ 'academy.topic.nextTopic' | translate: { n: nextTopic.number, name: nextTopic.title } }}
      <nb-icon icon="arrow-forward-outline"></nb-icon>
    </a>
  </nb-card-footer>
</nb-card>
